import React from "react";
import HeaderSection from "../../components/header";
import HeroSection from "../../components/herosection";
import Footer from "../../components/footerSection";
import call1 from "../../assets/callYellow.svg";
import gas from "../../assets/gasimage.png";
import pellet from "../../assets/pelletimage.png";
import wood from "../../assets/woodimage.png";
import electric from "../../assets/electricimage.png";
import gasstove from "../../assets/gasstove.png";
import "./sales.css";
import star from "../../assets/star_yellow.svg";
import ContactUsSection from "../../components/servicesSection/ContactUsSection";
import ContactUsSales from "./ContactUsSales";

function Sales() {
  return (
    <div className="Sales">
      <HeaderSection />
      <HeroSection />
      <div className="product-container">
        {[
          { image: gas, name: "Gas" },
          { image: pellet, name: "Pellet" },
          { image: wood, name: "Wood" },
          { image: electric, name: "Electric" },
        ].map((item) => (
          <div className="product-item ">
            <img src={item?.image} alt="" className="product-image" />
            <p className="product-name">{item?.name}</p>
          </div>
        ))}
      </div>

      <section className="same_width_container ">
        <div className="sales_all_box_container">
          {[1, 2].map(() => {
            return (
              <div className="sales_self_box shadow-lg">
                <div className="img_stove_container">
                  <div className="sales_text_container">Sale</div>
                  <img
                    src={gasstove}
                    alt=""
                    className="stove_image shadow-sm"
                  />
                </div>
                <div className="all_gas_content_container">
                  <p className="gas_title_name">
                    2017 REGENCY U38 B VENT GAS STOVE
                  </p>
                  <p className="gas_description">
                    Total satisfaction assured. Should any issues arise, we
                    promise prompt resolution, ensuring your peace of mind and
                    lasting satisfaction.
                  </p>
                  <p className="rating_star_text">
                    <img src={star} alt="star" loading="lazy" />
                    4.8
                  </p>
                  <p className="retails_price_text">
                    Retail Price : <span>$5111.00 + GST </span>
                  </p>
                  <p className="sales_price_title">
                    Sale Price : <span>$5111.00 + GST</span>{" "}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <ContactUsSales />
      <ContactUsSection />
      <Footer />
    </div>
  );
}

export default Sales;

// import React from 'react';
// import './sales.css';
// import HeaderSection from '../../components/header';
// import HeroSection from '../../components/herosection';
// import Footer from '../../components/footerSection';
// import call1 from "../../assets/callYellow.svg";
// import gas from '../../assets/gasimage.png';
// import pellet from '../../assets/pelletimage.png';
// import wood from '../../assets/woodimage.png';
// import electric from '../../assets/electricimage.png';
// import gasstove from '../../assets/gasstove.png';

// function Sales() {
//   return (
//     <div className="Sales">
//       <HeaderSection />
//       <HeroSection />
//       <div className='product-container'>
//         {[{image: gas, name: "Gas"}, {image: pellet, name: "Pellet"}, {image: wood, name: "Wood"}, {image: electric, name: "Electric"}].map((item) => (
//           <div className='product-item'>
//             <img src={item?.image} alt={item?.name} className='product-image' />
//             <p className='product-name'>{item?.name}</p>
//           </div>
//         ))}
//       </div>
//       <div className='image-container'>
//         <img src={gasstove} alt="Gas Stove" className='gas-stove-image' />
//       </div>
//       <div className="contact-container">
//         <p>Contact Us At</p>
//         <div className='contact-info'>
//           <img src={call1} alt="Call" className='contact-icon' />
//           <span className='contact-number'>9912673256</span>
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default Sales;
